import React from 'react';
import styled from 'styled-components';
import RichText from '../rich-text';
import { breakpoint } from '../theme/breakpoint';
import generateQS from '../styled/background-image';

const mobileHeight = '300px';
const tabletHeight = '380px';
const desktopHeight = '262px';
const imageSizes = {
  mobile: [350, 300], // 252-382 x 300
  tablet: [446, 380], // 304-446 x 380
  desktop: [554, 262], // 446-554 x 262
};

export const ImageWrapper = styled.div`
  background-size: cover;
  background-color: ${({ theme }) => theme.palette.lightBackground};
  background-position: ${({ $alignImage }) => `${$alignImage}`};
  background-image: ${({ $image: image, $alignImage: alignImage }) =>
    image && generateQS({ image, alignImage, imageSizes, size: 'mobile' })};

  height: ${mobileHeight};

  ${breakpoint.tablet`
    flex-grow: 1;
    flex-basis: 50%;
    height: ${tabletHeight};
    background-image: ${({ $image: image, $alignImage: alignImage }) =>
      image && generateQS({ image, alignImage, imageSizes, size: 'tablet' })};
  `};

  ${breakpoint.desktop`
    height: ${desktopHeight};
    background-image: ${({ $image: image, $alignImage: alignImage }) =>
      image && generateQS({ image, alignImage, imageSizes, size: 'desktop' })};
  `}
`;

export const ItemWrapper = styled.div`
  overflow: hidden;
  padding: ${({ theme }) => `${theme.spacing.standard} 0`};
  background-color: ${({ theme, $background }) =>
    $background === 'dark'
      ? theme.palette.darkBackground
      : theme.palette.white};
`;

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoint.tablet`
    flex-direction: ${({ $isOdd }) => ($isOdd ? 'row-reverse' : 'row')};
  `}
`;

export const TextWrapper = styled.div`
  position: relative;
  color: ${({ theme, $background }) =>
    $background === 'dark' ? theme.palette.white : theme.palette.standardText};

  ${breakpoint.tablet`
    flex-grow: 1;
    flex-basis: 50%;
    padding-left: ${({ theme, $isOdd }) => !$isOdd && theme.spacing.standard};
    padding-right: ${({ theme, $isOdd }) => $isOdd && theme.spacing.standard};
  `};
`;

export const StyledRichText = styled((props) => <RichText {...props} />)`
  color: inherit;
  // font scale to increase default to h4 size (18px > 21px)
  font-size: 1.16667em;

  p:last-of-type {
    margin-bottom: 0;
  }
`;

export const Title = styled.h3`
  color: inherit;
  text-transform: uppercase;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin: ${({ theme }) => `${theme.spacing.small} 0`};
`;

export const BrushElement = styled.img`
  width: 180px;
  height: 24px;
  margin-bottom: ${({ theme }) => theme.spacing.small};
`;

export const Header = styled.h2`
  margin: ${({ theme }) => `${theme.spacing.standard} 0`};
`;

export const ContentBlockWrapper = styled.div`
  margin-bottom: ${({ $removeMarginBottom, theme }) =>
    $removeMarginBottom ? '0' : theme.spacing.xlarge};
`;
